"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableCurrenciesSelectorWithNoMerchId = exports.availableCurrenciesSelector = exports.activeCurrencySelector = exports.customerCurrencyCodeSelector = void 0;

var CurrencyCodes = _interopRequireWildcard(require("self-service-api/constants/CurrencyCodes"));

var _availableCurrenciesAdapter = _interopRequireDefault(require("self-service-api/adapters/availableCurrenciesAdapter"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _reselect = require("reselect");

var customerCurrencyCodeSelector = function customerCurrencyCodeSelector(_ref) {
  var customerCurrencyCode = _ref.customerCurrencyCode;
  return customerCurrencyCode;
};

exports.customerCurrencyCodeSelector = customerCurrencyCodeSelector;

var activeCurrencySelector = function activeCurrencySelector(state) {
  var activeCurrencyCode = state.activeCurrencyCode;
  var customerCurrencyCode = customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
}; // TODO: With the new pricing page design, the concept of giving
// available currencies per merch is outdated.
// For now, we can hackily provide no merchandiseId, and get all CurrencyCodes back
// but this is worth reevaluating


exports.activeCurrencySelector = activeCurrencySelector;

var availableCurrenciesSelector = function availableCurrenciesSelector(state, merchandiseId) {
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var customerCurrencyCode = customerCurrencyCodeSelector(state);
  if (!merchandise) return []; // This check is temporary. See https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/pull/554

  if (customerCurrencyCode) return [customerCurrencyCode];
  if (!merchandiseId) return Object.values(CurrencyCodes || {});
  var productData = {
    products: merchandise,
    customerCurrencyCode: customerCurrencyCode
  };
  var availableCurrencies = (0, _availableCurrenciesAdapter.default)(productData, {
    itemConfigurations: [{
      merchandiseId: merchandiseId
    }]
  });
  return Object.keys(CurrencyCodes).filter(function (currency) {
    return availableCurrencies.includes(currency);
  });
};

exports.availableCurrenciesSelector = availableCurrenciesSelector;
var availableCurrenciesSelectorWithNoMerchId = (0, _reselect.createSelector)(customerCurrencyCodeSelector, function (customerCurrencyCode) {
  // This check is temporary. See https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/pull/554
  if (customerCurrencyCode) return [customerCurrencyCode];
  return Object.values(CurrencyCodes || {});
});
exports.availableCurrenciesSelectorWithNoMerchId = availableCurrenciesSelectorWithNoMerchId;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CurrencySelectors.js
// module id = 28
// module chunks = 5 6 7